<template>
  <div class="a-color-palette">
    <div class="color-grid">
      <div
        v-for="color in colorPalette"
        :key="color"
        class="color-item"
        :class="{ selected: selectedColor === color }"
        :style="{ backgroundColor: color }"
        @click="selectColor(color)"
        :title="color"
      >
        <v-icon v-if="selectedColor === color" size="16">
          mdi-check
        </v-icon>
        <span v-else :style="{ color: textColor(color) }">C</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as Utils from "@/utils.js";
import { mapState } from "vuex";

export default {
  name: "a-color-palette",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedColor: this.value
    };
  },
  computed: {
    colorPalette() {
      return this.chain.colors;
    },
    ...mapState({
      chain: state => state.chain.chain
    })
  },
  methods: {
    selectColor(color) {
      this.selectedColor = color;
      this.$emit("input", color);
      this.$emit("change", color);
    },
    textColor(color) {
      return Utils.intensifyColor(color);
    }
  },
  watch: {
    value(newValue) {
      this.selectedColor = newValue;
    }
  }
};
</script>

<style scoped lang="scss">
// Variables
$min-item-size: 30px;
$border-radius: 4px;
$border-width: 2px;
$gap-size: 4px;
$transition-speed: 0.2s;

.a-color-palette {
  .color-grid {
    display: grid;
    //grid-template-columns: repeat(auto-fill, minmax($min-item-size, 1fr));
    grid-template-columns: repeat(10, 1fr);
    gap: $gap-size;
    width: auto;
  }
  .color-item {
    aspect-ratio: 1; // Mantiene relación 1:1 (cuadrado)
    border-radius: $border-radius;
    cursor: pointer;
    border: $border-width solid transparent;
    transition: all $transition-speed ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: $min-item-size;
    &.selected,
    &:hover {
      border-color: #555;
      //transform: scale(1.05);
    }
  }
}
</style>
